import { useState } from "react";
import rawMaterialIcon from "../../assets/new-product-detail-cats/header-icons/raw-material-icon.svg";
import prodManufacturingIcon from "../../assets/new-product-detail-cats/header-icons/manufacturing-icon.svg";
import prodEnergyIcon from "../../assets/new-product-detail-cats/header-icons/energyIcon.svg";
import prodSurplusIcon from "../../assets/new-product-detail-cats/header-icons/surplus-resource-icon.svg";
import prodDeliveryIcon from "../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import prodTravelIcon from "../../assets/new-product-detail-cats/header-icons/prod-travel-icon.svg";
import ProdProcessingIcon from "../../assets/design-revamp-company/company-detail-headers/processing-icon.svg";
import prodUseOfSoldIcon from "../../assets/design-revamp-company/company-detail-headers/use-of-sold-icon.svg";
import prodFinalTreatmentIcon from "../../assets/design-revamp-company/company-detail-headers/final-treatment-icon.svg";
import BurgerIcon from "../../components/EditIconTable/BurgerIcon";
import yfsLabelIcon from "../../assets/new-product-detail-cats/yfs-label/yfs-prod-bg.svg";
import DiscardChangeIcon from "../../components/EditIconTable/DiscardChangeIcon";
import { t } from "i18next";

const SidebarItem = ({ icon, text, idElement }) => {
  const [hover, setHover] = useState(false);

  const scroll = () => {
    const section = document.querySelector(idElement);
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className="sidebar__item">
      <img
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        src={icon}
        alt=""
        onClick={scroll}
      />
      <h6 style={{ display: hover ? "block" : "none" }}>{text}</h6>
    </div>
  );
};

const Sidebar = () => {
  const [show, setShow] = useState(false);
  const [classRotate, setClassRotate] = useState(false);
  return (
    <>
      <div className="sidebar__navigation">
        <div
          className="sidebar__item"
          style={{ marginBottom: "20px", marginTop: "20px" }}
        >
          {show ? (
            <div
              className={classRotate ? "class_rotasi" : ""}
              onClick={(e) => {
                e.stopPropagation();
                setClassRotate(true);
                setTimeout(function () {
                  setShow(!show);
                  setClassRotate(false);
                }, 200);
              }}
              style={{
                width: "100%",
                marginLeft: "50px",
                zIndex: 3,
                cursor: "pointer",
              }}
            >
              <DiscardChangeIcon style={3} />
            </div>
          ) : (
            <div
              className={classRotate ? "class_rotasi" : ""}
              onClick={() => {
                setClassRotate(true);
                setTimeout(function () {
                  setShow(!show);
                  setClassRotate(false);
                }, 200);
              }}
              style={{ width: "100%", cursor: "pointer" }}
            >
              <BurgerIcon style={3} click={() => {}} />
            </div>
          )}
        </div>
        {show ? (
          <div className="sidebar__menus">
            <SidebarItem
              icon={rawMaterialIcon}
              text={t("RAW_MATERIALS")}
              idElement={"#raw-material-id"}
            />
            <SidebarItem
              icon={prodManufacturingIcon}
              text={t("MANUFACTURING_PROCESSES")}
              idElement={"#prod-manufacturing-id"}
            />
            <SidebarItem
              icon={prodEnergyIcon}
              text={t("ENERGY")}
              idElement={"#prod-energy-id"}
            />
            <SidebarItem
              icon={prodSurplusIcon}
              text={t("WASTE")}
              idElement={"#prod-surplus-id"}
            />
            <SidebarItem
              icon={prodDeliveryIcon}
              text={t("PROD_TRANSPORT")}
              idElement={"#prod-deliveries-id"}
            />
            <SidebarItem
              icon={prodTravelIcon}
              text={t("BUSINESS_TRAVEL")}
              idElement={"#prod-travel-id"}
            />
            <SidebarItem
              icon={ProdProcessingIcon}
              text={t("PROCESSING_SOLD_INTERMEDIATE")}
              idElement={"#processing-id"}
            />
            <SidebarItem
              icon={prodUseOfSoldIcon}
              text={t("USE_OF_SOLD_PRODUCTS")}
              idElement={"#comp-usc-id"}
            />
            <SidebarItem
              icon={prodFinalTreatmentIcon}
              text={t("FINAL_TREATMENT_PRODUCTS")}
              idElement={"#final-treatment-id"}
            />
            <SidebarItem
              icon={yfsLabelIcon}
              text={t("YFS Label")}
              idElement={"#yfs-label-id"}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default Sidebar;
